import { Action } from 'redux-actions'
import { HttpClient } from '@opallabs/api'
import { AssetReference } from '@opallabs/cassini'
import postAssetReference from '../postAssetReference'

const getConfig = (file: File) => {
  // Encode the header as Base64 to support UTF-8 Unicode characters
  const encodedFileName = window.btoa(unescape(encodeURIComponent(file.name)))

  return {
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-File-Name': encodedFileName,
    },
  } as const
}

type Handler = Readonly<{
  file: File
  onUploadFailure?: (error: Error, file: File) => void
  onUploadStart?: (file: File) => void
  onUploadSuccess?: (assetReference: AssetReference) => void
}>

const handleAssetUpload =
  ({ file, onUploadFailure, onUploadStart, onUploadSuccess }: Handler) =>
  (): Action<Record<never, never>> => {
    onUploadStart?.(file)

    HttpClient()
      .post('/assets/v2', file, getConfig(file))
      .then((assetResp) => postAssetReference(assetResp.data))
      .then((assetRefResponse) => {
        onUploadSuccess?.(assetRefResponse.data as AssetReference)
        return null
      })
      .catch((error: Error) => {
        onUploadFailure?.(error, file)
        throw error
      })

    return {
      type: 'ASSET UPLOADED',
      payload: {},
    }
  }

export default handleAssetUpload
